export default __webpack_public_path__ + "static/media/groovy.7e37b796.svg";